import { mapChannelGroupFromSysApi, mapDurationFromSysApi } from '@shure/shared/angular/data-access/system-api/mappers';

import { DelayChannel } from '../../api';
import { DelayChannelFragment } from '../graphql/generated/delay.generated';

export function mapDelayChannelFromSysApi(channel: DelayChannelFragment): DelayChannel {
	const {
		id,
		features,
		description: { constraints }
	} = channel;
	return {
		id,
		name: channel.features.name?.name,
		group: mapChannelGroupFromSysApi(channel.description.groupName),
		features: {
			delay: {
				enabled: features.delay?.enabled || false,
				delay: features.delay?.delay ? mapDurationFromSysApi(features.delay?.delay) : 0
			},
			channelConfiguration: channel.description.features.channelConfiguration.supported
				? {
						enabled: channel.features.channelConfiguration?.enabled || false,
						isMissing: channel.features.channelConfiguration === null
				  }
				: undefined
		},
		constraints: {
			range: {
				min: constraints.delay?.delay.range.min ? mapDurationFromSysApi(constraints.delay.delay.range.min) : 0,
				max: constraints.delay?.delay.range.max
					? mapDurationFromSysApi(constraints.delay.delay.range.max)
					: 1000,
				step: constraints.delay?.delay.range.step
					? mapDurationFromSysApi(constraints.delay.delay.range.step)
					: 0.1
			}
		}
	};
}
